module.exports = __webpack_public_path__ + "static/media/banner_convocadas_mobile.3df750ae.webp";